import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import PublicShare from './components/PublicShare';
import Home from './pages/Home';
import AdminPanel from './pages/AdminPanel';
import VerifyEmail from './pages/VerifyEmail';
import ResetPassword from './pages/ResetPassword';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/share/:shareId" element={<PublicShare />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/app/*" element={<App />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;